"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
const class_validator_1 = require("class-validator");
const BaseConnection_1 = tslib_1.__importDefault(require("./BaseConnection"));
class GasConnection extends BaseConnection_1.default {
}
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'Expected yearly consumption in m3',
        example: 1500,
    }),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Number)
], GasConnection.prototype, "consumption", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(offerstore_api_models_1.GasInstallationProfile)),
    (0, base_models_1.Docs)({
        example: offerstore_api_models_1.GasInstallationProfile.G1A,
        description: `The profile of the gas meter/installation.
Describes the maximum usage of the building.
Heavily influences the supply rates.
We try to find the profile if it is an existing customer, otherwise it will default to G1A.`,
    }),
    tslib_1.__metadata("design:type", String)
], GasConnection.prototype, "installationProfile", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '8742010202112',
        description: `States per netbeheerder the maximum amount of gas in m3 per hour the building is allowed to use.
For example, if the gas installation has the captar 8742080201114 is then managed by NV Rendo and states the maximum input is 10m3/h with a maximum year usage of less than 500m3 gas.
This value can be retrieved at EDSN for everyone.
This heavily influences the tariffs you receive.
You find the result under "Netbeheerder kosten".`,
    }),
    tslib_1.__metadata("design:type", String)
], GasConnection.prototype, "captarEAN", void 0);
exports.default = GasConnection;
